import React, { Fragment, useState } from 'react';
import butter from './butter-client'
import { Helmet } from 'react-helmet'

// import moment from 'moment';
import { CaretLeftOutlined } from '@ant-design/icons';
import { Container, Row, Col, Image } from 'react-bootstrap';

import './BlogStyle.css';
// import './BlogContent.css';


export default class extends React.Component {
  state = {
    data: {}
  }
  async componentDidMount() {
    const { match } = this.props
    const resp = await butter.post.retrieve(match.params.post)
    this.setState(resp.data)
  }
  render() {
    const post = this.state.data


    return (
      <div>
        <Helmet>
          <title>{post.seo_title}</title>
          <meta name='description' content={post.meta_description} />
          <meta name='og:image' content={post.featured_image} />
        </Helmet>

        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Image className="blog-post-img mt-5 mb-2" fluid src={post.featured_image} />
              <a href="/blog" className="align-middle"><CaretLeftOutlined className="align-middle pb-1" /> Back To Posts</a>
              <h1 className="pt-4 fs-36 bps-midnight">{post.title}</h1>
              <div dangerouslySetInnerHTML={{ __html: post.body }} />
              <p className="border-top border-bottom py-4">
                Ready to take the next step? At Best Payment Solutions, we understand the impact an improvement to your sales cycle can make on your company's financials. Our experienced team can help your business evaluate its processes and implement a channel partner automation program to meet its unique needs. If you're ready to take your business to a whole new level and get your sales process functioning at peak efficiency when you need it most, then a channel partner incentive program may be the right solution for you. <a href="/contactus" className="BPS-text-link">Click here</a> to schedule a consultation, or give us a call at 800-371-6801.
              </p>
            </Col>
          </Row>
        </Container>

      </div>
    )
  }
}